import * as Yup from 'yup';

const topicsSchema = Yup.object().shape({
  selectedTopics: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }),
});

export default topicsSchema;
